module.exports = __webpack_public_path__ + "img/banner_feria_2025.d6dcc714.jpg";